import * as React from 'react';
import Head from 'next/head';
import Main, { makeTitle } from '@/components/layouts/Main';
import ContactUsForm from '@/components/forms/ContactUsForm';
import BoxFull from '@/components/box/BoxFull';

const ChangePassword = () => {
  return (
    <>
      <Head>
        <title>{makeTitle('Secure your account')}</title>
      </Head>

      <BoxFull type={'happy'} title={`Leave us a message`} mainTitle={`Contact us`}>
        <ContactUsForm />
      </BoxFull>
    </>
  );
};

ChangePassword.Layout = Main;

export default ChangePassword;
